import {
  declarePluralStringWithPlaceholders,
  declareString,
} from "@1js/localization";

export const SearchedPromptsTitle = declarePluralStringWithPlaceholders(
  "promptLibrary.searchedPromptsTitle",
  {
    strings: ({ promptCount, searchQuery }) => {
      return {
        one: `Search result for "${searchQuery}" (${promptCount})`,
        other: `Search results for "${searchQuery}" (${promptCount})`,
      };
    },
    comment:
      "Title displayed in the header of the prompt library page when user performs a search. The title includes the searched query and the number of prompts found.",
    placeholders: {
      promptCount: "the number of Copilot prompts found",
      searchQuery: "the query searched",
    },
  }
);

export const NoSearchResultHeading = declareString(
  "promptLibrary.noSearchResultHeading",
  {
    text: "We didn't find anything that matches your search",
    comment:
      "Heading displayed on the screen when the request to fetch Copilot prompts from the server-side retruns zero results.",
  }
);

export const NoSearchResultSubHeading = declareString(
  "promptLibrary.noSearchResultSubheading",
  {
    text: "Try searching again using a different word or phrase.",
    comment:
      "Subheading displayed on the screen when the request to fetch Copilot prompts from the server-side retruns zero results.",
  }
);

export const SearchWentWrongHeading = declareString(
  "promptLibrary.searchWentWrongHeading",
  {
    text: "Looks like something went wrong.",
    comment:
      "Heading displayed on the screen when something went wrong during an user's search for Copilot Prompts.",
  }
);

export const SearchWentWrongSubheading1 = declareString(
  "promptLibrary.searchWentWrongSubheading1",
  {
    text: "We were unable to load the search results.",
    comment:
      "The first subheading displayed on the screen when something went wrong during an user's search for Copilot Prompts.",
  }
);

export const SearchWentWrongSubheading2 = declareString(
  "promptLibrary.searchWentWrongSubheading2",
  {
    text: "Please try again later.",
    comment:
      "The second subheading displayed on the screen when something went wrong during an user's search for Copilot Prompts.",
  }
);
